// 需求清单任务数据
let orderItemModel = {
    orderId: null,
    itemDesc: null,
    money: null,
    outboundUserId: null,
    outboundUser: null,
    isPay: false,
    isDeliver: false
}
export default orderItemModel;